import React from "react";
import styles from "./BetTableTeen8.module.css";

// Helper function to parse card string and convert to display format
// Card format: "10SS,8HH,ADD" or similar card codes
// Returns array of objects with value and suit symbol
const parsePlayerCards = (cardString, playerIndex) => {
  if (!cardString) return [];
  
  const cards = cardString.split(',').map(c => c.trim());
  
  // Get 3 cards for this player (players are 0-7, each has 3 cards)
  const startIndex = playerIndex * 3;
  const playerCards = cards.slice(startIndex, startIndex + 3);
  
  // Convert card codes to display format
  // Format: "10SS" -> { value: "10", suit: "[", isRed: false }
  // Suit mapping: S=Spade=[, H=Heart={, D=Diamond=}, C=Club=]
  const suitMap = {
    'S': { symbol: '[', isRed: false },
    'H': { symbol: '{', isRed: true },
    'D': { symbol: '}', isRed: true },
    'C': { symbol: ']', isRed: false }
  };
  
  return playerCards.map(card => {
    if (!card) return null;
    
    // Try to parse card code like "10SS", "8HH", "ADD"
    const match = card.match(/^([A-Z0-9]+)([SHDC])([SHDC])?$/);
    if (match) {
      const value = match[1];
      const suit = match[2];
      const suitInfo = suitMap[suit] || { symbol: '', isRed: false };
      return {
        value,
        suit: suitInfo.symbol,
        isRed: suitInfo.isRed
      };
    }
    
    return null;
  }).filter(Boolean);
};

const BetTableTeen8 = ({ 
  data = [], 
  exposures = {}, 
  min = 100, 
  max = 100000, 
  pairPlusMin = 100, 
  pairPlusMax = 10000, 
  formatMax = (v) => {
    if (v >= 1000) {
      return `${(v/1000).toFixed(0)}K`;
    }
    return v.toString();
  }, 
  cardString = "" 
}) => {
  // Get exposure value
  const getExposure = (label) => {
    const exposureKeys = [
      label,
      label.toLowerCase(),
      label.trim(),
      label.toLowerCase().trim(),
    ].filter(Boolean);

    for (const key of exposureKeys) {
      if (exposures[key] !== undefined && exposures[key] !== 0) {
        return parseFloat(exposures[key]) || 0;
      }
    }
    return 0;
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined;
  };

  return (
    <div className={`${styles.casinoDetail} ${styles.casinoBox}`}>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className={styles.box5}></th>
              <th className={`${styles.box2} ${styles.back} ${styles.textCenter}`}>
                Back(Min:
                <span>{min}</span> Max:
                <span>{formatMax(max)}</span>)
              </th>
              <th className={`${styles.box3} ${styles.back} ${styles.textCenter}`}>
                Min:
                <span>{pairPlusMin}</span> Max:
                <span>{formatMax(pairPlusMax)}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              const playerNumber = index + 1;
              const playerName = row?.nat || `Player ${playerNumber}`;
              const backSuspended = isSuspended(row.oddsData);
              const pairPlusSuspended = isSuspended(row.pairPlusData);
              
              const backValue = row?.odds || 0;
              const backExposure = row?.oddsData?.bs || getExposure(playerName) || 0;
              
              const pairPlusValue = row?.pairPlus || 0;
              const pairPlusExposure = row?.pairPlusData?.bs || getExposure(`Pair Plus ${playerNumber}`) || 0;
              
              // Parse cards for this player
              const playerCards = parsePlayerCards(cardString, index);

              const rowSuspended = backSuspended || pairPlusSuspended;

              return (
                <tr key={index} className={rowSuspended ? styles.suspended : ""}>
                  <td className={styles.box5}>
                    <b>{playerName}</b>
                    {playerCards.length > 0 && (
                      <p className={`${styles.mB0} ${styles.dInlineBlock} ${styles.playerCards}`}>
                        {playerCards.map((card, cardIndex) => (
                          <span key={cardIndex} className={styles.cardIcon}>
                            {card.value}
                            <span className={card.isRed ? styles.cardRed : styles.cardBlack}>
                              {card.suit}
                            </span>
                          </span>
                        ))}
                      </p>
                    )}
                  </td>
                  <td className={`${styles.textCenter} ${styles.box2} ${styles.back}`}>
                    <span className={`${styles.dBlock} ${styles.textBold}`}>{backValue || "0"}</span>
                    <span className={styles.dBlock} style={{ color: 'black' }}>
                      {backExposure || "0"}
                    </span>
                  </td>
                  <td className={`${styles.textCenter} ${styles.box3} ${styles.back}`}>
                    <span className={`${styles.dBlock} ${styles.textBold}`}>
                      <b>Pair Plus {playerNumber}</b>
                    </span>
                    <span className={styles.dBlock} style={{ color: 'black' }}>
                      {pairPlusExposure || "0"}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BetTableTeen8;

